module.exports = __webpack_public_path__ + "img/youtube.3a3f1183.svg";